import { useContext } from 'react';
import { LocalizationContext } from "../context/localization-context.js";
export const useLocalization = () => useContext(LocalizationContext);
//# sourceMappingURL=use-localization.js.map